export { ConferenceSessionMobileInfo } from './ConferenceSessionMobileInfo';
